import React, { Component, Fragment } from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { map, get, isEmpty } from 'lodash';
import { graphql } from 'react-apollo';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';

import { DELETE_TEAM } from '../events/graphql';
import { HHInput, HHTinyMCE, HHSingleSelect, HHMultipleSelect, HHTextArea } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import ConfirmationModal from '../common/confirmationModal';
import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { fetchTags, handleResponseCode } from '../actions';
import { fetchUserTeam } from '../actions/event';


const formikEnhancer = withFormik({
  validationSchema: ({ team, event, translate }) => {
    let minTeamLimit = 0;
    if (team && team.members) {
      minTeamLimit = team.members.length;
    }

    const maxTeamLimit = event.maxTeamMembers || 5;

    return Yup.object().shape({
      name: Yup
        .string().min(1, translate('form.error.string.min'))
        .max(60, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required')),
      limit: Yup
        .number()
        .positive('form.error.number.positive')
        .min(minTeamLimit, translate('form.error.number.min'))
        .max(maxTeamLimit, translate('form.error.number.max')),
      description: Yup.string(),
      roleTags: Yup.array()
        .min(1, translate('form.error.array.min'))
        .max(10, translate('form.error.array.max'))
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required()
          })
        ),
      idea: Yup.string().required(translate('form.error.mixed.required')).min(1, translate('form.error.string.min')).max(5000, translate('form.error.string.max'))
    });
  },
  mapPropsToValues: ({ initialValues }) => ({ ...initialValues }),
  handleSubmit: (values, { props, setSubmitting }) => {
    // format roleTags to array of strings
    const submittedValues = {
      ...values,
      roleTags: map(values.roleTags, tag => tag.value)
    };

    props.handleSubmit(submittedValues, { setSubmitting });
  },
  displayName: FORM_NAME.EDIT_TEAM_FORM
});

class EventTeamForm extends Component {
  componentWillMount() {
    // TODO graphql query
    const { tagOptions } = this.props;
    if (!tagOptions.length) {
      this.props.fetchTags();
    }
  }

  handleDeleteTeam = async () => {
    // TODO refactor this part
    if (this.props.team.members.length > 1) {
      HHAlert({ id: 'alert.warning.deleteTeamWithTeamMembers' }, ALERT_TYPE.WARNING);
    } else {
      const {
        user,
        event: { slug },
        team,
        deleteTeam,
        fetchUserTeam,
        history
      } = this.props;

      const userId = get(user, 'profile.basicInfo.id');
      const res = await deleteTeam({
        variables: { token: user.token, teamId: team.id }
      });
      const { code } = res.data.deleteTeam;
      handleResponseCode(code);

      if (code === 200) {
        await fetchUserTeam(userId, slug);
        history.push(`/event/${slug}/teams`);
      }
    }
  };

  redirectToMyTeam = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { event: { slug } } = this.props;
    this.props.push(`/event/${slug}/my-team`);
  };

  render() {
    const {
      team,
      user,
      event: { maxTeamMembers, slug },
      tagOptions,
      isEditing,
      handleSubmit,
      isSubmitting,
      translate,
      errors
    } = this.props;

    const limtOptions = [];
    for (let i = 1; i <= maxTeamMembers; i += 1) {
      limtOptions.push({ value: i, label: i });
    }

    return (
      <Fragment>
        <div className='reactModal_header'>
          <h1 className='reactModal_header_title'>{translate(isEditing ? 'Edit My Team' : 'Create My Team')}</h1>
        </div>
        <div className='reactModal_content'>
          <Form className='editProject' onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Field width={10}>
                <label htmlFor='name'>{translate('Team Name Required')}</label>
                <Field
                  name='name'
                  component={HHInput}
                  otherProps={{
                    id: 'name',
                    placeholder: translate('Team Name'),
                    maxLength: 60,
                    className: 'ui input'
                  }}
                />
              </Form.Field>
              <Form.Field width={6}>
                <label htmlFor='limit'>{translate('Team Size Required')}</label>
                <Field
                  name='limit'
                  component={HHSingleSelect}
                  otherProps={{
                    id: 'limit',
                    placeholder: translate('form.placeholder.teamLimit'),
                    options: limtOptions,
                    simpleValue: true,
                    searchable: false,
                    clearable: false
                  }}
                />
              </Form.Field>
            </Form.Group>

            <Form.Field>
              <label htmlFor='roleTags'>{translate('Skills Needed')}</label>
              <Field
                name='roleTags'
                component={HHMultipleSelect}
                otherProps={{
                  id: 'roletags',
                  options: tagOptions,
                  creatable: true,
                  placeholder: translate('form.placeholder.tags.topSkills')
                }}
              />
              <small className='aside-text'>{`${translate('max.tags.num')} 10.`}</small>
            </Form.Field>

            <Form.Field>
              <label htmlFor='idea'>{translate('projectIdea')}*</label>
              <Field
                name='idea'
                component={HHTextArea}
                otherProps={{
                  id: 'idea',
                  type: 'text',
                  placeholder: translate('enterProjectIdea')
                }}
              />
            </Form.Field>

            <Form.Field>
              <label>{translate('project.description')}</label>
              <Field
                name='description'
                component={HHTinyMCE}
                fileType='team_description'
                slug={slug}
                user={user}
                // userToken={user.token}
                teamId={team ? team.id : ''}
              />
            </Form.Field>

            <div className='g-form-footer'>
              {isEditing && (
                <Fragment>
                  <ConfirmationModal
                    title={`${translate('do.you.want.to.delete')}${team.name}?`}
                    cancelText={translate('no')}
                    confirmText={translate('yes')}
                    handleConfirm={this.handleDeleteTeam}
                    trigger={
                      <Button
                        type='button'
                        className='common-cancel-button'
                      >
                        {translate('teamDetailCard.dismissTeam')}
                      </Button>
                    }
                  />
                  <Button
                    type='button'
                    className='team-detail-button'
                    onClick={(e) => this.redirectToMyTeam(e)}
                  >
                    {translate('button.back')}
                  </Button>
                </Fragment>
              )}

              <Button
                size='medium'
                type='submit'
                className='team-detail-button'
                disabled={isSubmitting || !isEmpty(errors)}
                loading={isSubmitting}
              >
                {translate(isEditing ? 'save' : 'create')}
              </Button>
            </div>
          </Form>
        </div>
      </Fragment>
    );
  }
}

export default compose(
  withLocalize,
  withRouter,
  connect(({ user, tags }) => ({
    user,
    tagOptions: tags.tagOptions || []
  }), {
    fetchTags, push, fetchUserTeam
  }),
  graphql(DELETE_TEAM, { name: 'deleteTeam' }),
  formikEnhancer
)(EventTeamForm);



// WEBPACK FOOTER //
// ./src/components/forms/eventTeamForm.js